export default (editor, config = {}) => {
    const tm = editor.TraitManager;

    tm.addType('custom-textarea', {
        events: {
            keyup: 'onChange',
            change: 'onChange',
        },

        onValueChange() {
            const md = this.model;
            const target = md.target;

            target.set('custom-textarea', md.get('value'));
        },

        getInputEl() {
            if (!this.inputEl) {
                const el = document.createElement('textarea');

                el.value = this.target.get('custom-textarea') || '';
                el.placeholder =
                    this.model.get('placeholder') ||
                    'Text, HTML, SVG, etc.';

                // Initial size (about 4 lines)
                el.rows = 4;

                // Allow user resizing
                el.style.resize = 'vertical';
                el.style.minHeight = '100px';
                el.style.width = '100%';
                el.style.boxSizing = 'border-box';

                this.inputEl = el;
            }

            return this.inputEl;
        },
    });
};
